import React from "react";
import DEMO from "./../../../../../store/constant";
import Aux from "../../../../../hoc/_Aux";

import logo from "../../../../../assets/images/logo/logo-main.png";
import mobileLogo from "../../../../../assets/images/logo/logo-icon.svg";

const navLogo = (props) => {
  const version = process.env.REACT_APP_VERSION;

  let toggleClass = ["mobile-menu"];
  let toggleLogo = ["logo-login"];
  let toggleIconLogo = ["logo-icon"];
  if (props.collapseMenu) {
    toggleClass = [...toggleClass, "on"];
    toggleIconLogo = [...toggleIconLogo, "on"];
    toggleLogo = [...toggleLogo, ""];
  } else {
    toggleIconLogo = [...toggleIconLogo, ""];
    toggleLogo = [...toggleLogo, "on"];
  }

  const link = window.sessionStorage.getItem("route");

  return (
    <Aux>
      <div className="navbar-brand header-logo">
        {/* <a href={DEMO.BLANK_LINK} className="b-brand"> */}
        <a href={link ? link : "/"} className="b-brand">
          {/* <div className="b-bg">
                        <i className="feather icon-trending-up" />
                    </div>
                    <span className="b-title">CPMS</span> */}
          <div
            className={toggleLogo.join(" ")}
            style={{ display: "flex", alignItems: "end" }}
          >
            <img className="" src={logo} alt="angkor chat" />
            <span style={{ fontSize: "14px", marginLeft: "5px" }}>
              {version}
            </span>
          </div>
          {/* <div className={toggleIconLogo.join(" ")}>
            <img
              className="mobile-angkor-logo"
              src={mobileLogo}
              alt="angkor chat"
            />
          </div> */}
        </a>
        {/* <a
          href={DEMO.BLANK_LINK}
          className={toggleClass.join(" ")}
          id="mobile-collapse"
          onClick={props.onToggleNavigation}
        >
          <span />
        </a> */}
      </div>
    </Aux>
  );
};

export default navLogo;
